import styled from "styled-components";

export default styled.div`
  max-width: 1300px;
  margin: auto;
  padding: 0 24px;
  @media (max-width: 600px) {
    padding: 0;
  }
`;
